import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class TermLink extends PureComponent {
  static propTypes = {
    term: PropTypes.objectOf(PropTypes.any).isRequired,
    className: PropTypes.string,
    v2Key: PropTypes.string,
    v2Info: PropTypes.string
  };

  render() {
    const { term, className, linkLabel, v2Info, v2Key } = this.props;

    const { termId, revisionId, additionalData } = term;

    const label = linkLabel ? linkLabel : additionalData && additionalData.name;

    const getTermLink = () => {
      if (v2Info.businessIds && v2Info.businessIds !== 'undefined') {
        return (
          <Link to={`/${termId}/${revisionId}/${v2Key}`} target="_blank">
            {label} <i className="fa fa-external-link" />
          </Link>
        );
      } else {
        return (
          <Link to={`/${termId}/${revisionId}`} target="_blank">
            {label} <i className="fa fa-external-link" />
          </Link>
        );
      }
    };
    return (
      <div className={className} key={`${termId}${revisionId}`}>
        {' '}
        {getTermLink()}{' '}
      </div>
    );
  }
}
